<template>
    <div>
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator';
    import dateHelper, {isToday} from '../../utils/portuna/dateHelper';
    import {WidgetDefault} from './WidgetDefault.vue';

    @Component({
        name: 'WidgetCalendarDefault',
        methods: {
            isToday,
            dateHelper,
        },
    })
    export class WidgetCalendarDefault<T extends IWidgetCalendarDefaultEntry> extends WidgetDefault
    {
        get entries(): T[]
        {
            const entries = this.content.entries as T[];

            return this.widget.isPersonalDashboardPopupWidget ? entries.map(entry =>
            {
                entry.timeString  = entry.entry_start_time && entry.recurrence_start ? this.buildTime(entry) : '';
                entry.timeToolTip = entry.entry_start_time && entry.recurrence_start ? this.buildTimeTooltip(entry) : null;

                return entry;
            }) : entries;
        }

        buildLink(entry: T): string
        {
            if (entry.resource === 'shift-schedule')
            {
                return 'employee/shift-schedule/calendar/index/' + entry.recurrence_start + '/' + entry.work_group_id;
            }

            if (entry.viewLink)
            {
                return entry.viewLink;
            }

            return '/' + (entry.resource !== this.widget.resource ? entry.resource : this.content.route) + '/entry/view/id/' + entry.id + '/start/' + entry.recurrence_start;
        }

        buildColor(color: string): string
        {
            return color.startsWith('#') || color.startsWith('rgb') ? color : ('#' + color);
        }

        buildTime(entry: T): string
        {
            const startDate  = new Date(entry.recurrence_start + ' ' + entry.entry_start_time);
            const endDate    = new Date(entry.recurrence_end + ' ' + entry.entry_end_time);
            const todayStart = new Date().setHours(0, 0, 0);
            const todayEnd   = new Date().setHours(23, 59, 59);
            const startTime  = startDate.getTime();
            const endTime    = endDate.getTime();

            if (startTime <= todayStart && endTime >= todayEnd)
            {
                return 'Ganztägig,';
            }

            if (startTime <= todayStart && !(endTime >= todayEnd))
            {
                return `Bis ${endDate.toLocaleTimeString()} Uhr,`;
            }

            if (endTime >= todayEnd && !(startTime <= todayStart))
            {
                return `Ab ${startDate.toLocaleTimeString()} Uhr,`;
            }

            return dateHelper('H:i', startDate) + ' - ' + dateHelper('H:i', endDate) + ' Uhr,';
        }

        buildTimeTooltip(entry: T): Nullable<string>
        {
            return (!isToday(entry.recurrence_start) || !isToday(entry.recurrence_end)) ? (
                'Von: ' + new Date(entry.recurrence_start + ' ' + entry.entry_start_time).toLocaleString() + ' Uhr<br>' +
                'Bis: ' + new Date(entry.recurrence_end + ' ' + entry.entry_end_time).toLocaleString() + ' Uhr'
            ) : null;
        }
    }

    export default WidgetCalendarDefault;
</script>